import { AppShell } from "@/components/layout/app-shell";
import { useAuth } from "@/hooks/use-auth";
import { DashboardPage } from "@/pages/dashboard";
import { LandingPage } from "@/pages/landing";
import { LoginPage } from "@/pages/login";
import { MessagesPage } from "@/pages/messages";
import { OrdersPage } from "@/pages/orders";
import { RegisterPage } from "@/pages/register";
import { StoreDetailPage } from "@/pages/store-detail";
import { StoresPage } from "@/pages/stores";
import AccountPage from "@/pages/account";
import { BrowserRouter, Navigate, Outlet, Route, Routes } from "react-router-dom";

function ProtectedRoute() {
	const { user, loading } = useAuth();

	if (loading) {
		return (
			<div className="flex h-screen items-center justify-center text-muted-foreground">
				Loading...
			</div>
		);
	}

	if (!user) {
		return <Navigate to="/login" replace />;
	}

	return <Outlet />;
}

function PublicOnlyRoute() {
	const { user, loading } = useAuth();

	if (loading) {
		return (
			<div className="flex h-screen items-center justify-center text-muted-foreground">
				Loading...
			</div>
		);
	}

	if (user) {
		return <Navigate to="/" replace />;
	}

	return <Outlet />;
}

export function App() {
	return (
		<BrowserRouter>
			<Routes>
                {/* Public routes (redirect to dashboard if already logged in) */}
                <Route element={<PublicOnlyRoute />}>
                    <Route path="/login" element={<LoginPage />} />
                    <Route path="/register" element={<RegisterPage />} />
                </Route>

                {/* Public landing page at root */}
                <Route path="/" element={<LandingPage />} />

            {/* Protected routes */}
            <Route element={<ProtectedRoute />}>
                <Route element={<AppShell />}>
                    <Route path="/app" element={<DashboardPage />} />
                    <Route path="/stores" element={<StoresPage />} />
                    <Route path="/stores/:id" element={<StoreDetailPage />} />
                    <Route path="/messages" element={<MessagesPage />} />
                    <Route path="/orders" element={<OrdersPage />} />
                    <Route path="/account" element={<AccountPage />} />
                </Route>
            </Route>

				{/* Catch-all */}
				<Route path="*" element={<Navigate to="/" replace />} />
			</Routes>
		</BrowserRouter>
	);
}
